import React from 'react';

import { ShareVariantIcon, ImportIcon } from '@vlabs/icons';
import { ExportTaskButton } from '@vlabs/monokit/features';
import { CreateCardFace } from '@vlabs/monokit/features/create-face';
import { PackageImportButton } from '@vlabs/monokit/features/package-import';
import { FilterMenuButton } from '@vlabs/monokit/shared/ui/filter-menu';
import { usePageContext } from '@vlabs/monokit/shared/ui/page';
import { useTranslation } from 'react-i18next';

import type { TListCardsFilters } from '../../types';
import { useListFacesPageFilters } from '../../useListDetailsFilters';

function getActiveFiltersCount(filters: TListCardsFilters): number {
  const {
    create_time__gte, create_time__lt, page, page_size, ...rest
  } = filters;
  const isDateFilterSelect = create_time__gte !== undefined || create_time__lt !== undefined;

  const restCount = Object.values(rest).filter((value) => value != null).length;

  return restCount + (isDateFilterSelect ? 1 : 0);
}

export function ListFacesActions(): React.JSX.Element {
  const { t } = useTranslation();
  const pageCtx = usePageContext();
  const { filters } = useListFacesPageFilters();

  return (
    <React.Fragment>
      <CreateCardFace title={t('list-details-page:list_faces_actions.create_face_label')} />
      <ExportTaskButton
        icon={<ShareVariantIcon />}
        kind="secondary"
        objectType="faces"
        size={pageCtx.buttonSize}
      >
        {t('list-details-page:list_faces_actions.export')}
      </ExportTaskButton>
      <PackageImportButton
        icon={<ImportIcon />}
        kind="secondary"
        size={pageCtx.buttonSize}
      >
        {t('list-details-page:list_faces_actions.import')}
      </PackageImportButton>
      <FilterMenuButton filtersCount={getActiveFiltersCount(filters)} />
    </React.Fragment>
  );
}
